// Akıllı CV Oluşturucu, Zenginleştirilmiş Akış
// Faz 1: Detaylı CV | Faz 2: Yurt dışı modülü (opsiyonel)

export const SECTIONS = [
  { id: 'personal', title: 'Kişisel Bilgiler', phase: 'cv' },
  { id: 'experience', title: 'İş Deneyimi', phase: 'cv' },
  { id: 'education', title: 'Eğitim', phase: 'cv' },
  { id: 'skills', title: 'Beceriler ve Yetkinlikler', phase: 'cv' },
  { id: 'cvFinish', title: 'CV Tamamla', phase: 'cv' },
  { id: 'abroad_pivot', title: 'Yurt Dışı Fırsatları', phase: 'cv' },
  { id: 'abroad_profile', title: 'Kariyer Profili', phase: 'abroad' },
  { id: 'abroad_target', title: 'Hedef İş ve Ülke', phase: 'abroad' },
  { id: 'abroad_visa', title: 'Göç ve Vize Durumu', phase: 'abroad' },
  { id: 'abroad_value', title: 'Değer Öneriniz', phase: 'abroad' },
  { id: 'abroad_adapt', title: 'Kültürel Uyum', phase: 'abroad' },
  { id: 'abroad_finish', title: 'Tamamla', phase: 'abroad' },
];

const QUESTIONS = [

  // ══════════════════════════════════════════════
  // FAZ 1: DETAYLI CV
  // ══════════════════════════════════════════════

  // Kişisel Bilgiler
  {
    id: 'greeting',
    section: 'personal',
    text: 'Merhaba! Ben isBulsun yapay zeka asistanıyım. Birlikte profesyonel bir CV oluşturacağız.\n\nAdınızı ve soyadınızı yazın.',
    type: 'text',
    field: 'fullName',
  },
  {
    id: 'headline',
    section: 'personal',
    text: 'Hangi pozisyon veya ünvanla CV\'nizin başında görünmek istersiniz?\n\n(Örn: "Kıdemli Yazılım Mühendisi", "Çocuk Gelişimi Uzmanı")',
    type: 'text',
    field: 'title',
  },
  {
    id: 'phone',
    section: 'personal',
    text: 'Telefon numaranızı yazın. (Örn: +90 532 123 4567)',
    type: 'text',
    field: 'phone',
  },
  {
    id: 'email',
    section: 'personal',
    text: 'E-posta adresinizi yazın.',
    type: 'text',
    field: 'email',
  },
  {
    id: 'location',
    section: 'personal',
    text: 'Şu an yaşadığınız şehir ve ülke?',
    type: 'text',
    field: 'location',
  },
  {
    id: 'linkedin',
    section: 'personal',
    text: 'LinkedIn profiliniz veya portfolyo/web siteniz var mı? Varsa linkini yazın. (yoksa "yok")',
    type: 'text',
    field: 'linkedin',
  },
  {
    id: 'birth_date',
    section: 'personal',
    text: 'Doğum tarihiniz? (Gün/Ay/Yıl, paylaşmak istemiyorsanız "geç" yazabilirsiniz)',
    type: 'text',
    field: 'birthDate',
  },
  {
    id: 'marital_status',
    section: 'personal',
    text: 'Medeni haliniz?',
    type: 'choice',
    choices: [
      { label: 'Bekar', value: 'Bekar' },
      { label: 'Evli', value: 'Evli' },
      { label: 'Belirtmek istemiyorum', value: 'yok' },
    ],
    field: 'maritalStatus',
  },
  {
    id: 'military_status',
    section: 'personal',
    text: 'Askerlik durumunuz nedir? (Erkek adaylar için; ilgili değilse "yok" seçebilirsiniz)',
    type: 'choice',
    choices: [
      { label: 'Yapıldı', value: 'Yapıldı' },
      { label: 'Muaf', value: 'Muaf' },
      { label: 'Tecilli', value: 'Tecilli' },
      { label: 'İlgili değil / Belirtmek istemiyorum', value: 'yok' },
    ],
    field: 'militaryStatus',
  },
  {
    id: 'summary',
    section: 'personal',
    text: 'Kendinizi kısaca tanıtın. Bu bilgi CV\'nizdeki profesyonel özet olarak yer alacak.\n\n(Örn: "22 yıl deneyimli CTO ve yapay zeka geliştirici" veya "20 yıllık lojistik uzmanı, ithalat-ihracat operasyonlarında deneyimli")',
    type: 'textarea',
    field: 'summary',
  },

  // İş Deneyimi (birleştirilmiş sorular)
  {
    id: 'exp_info',
    section: 'experience',
    text: 'İş deneyiminizi anlatın:\n\n- Şirket adı ve pozisyonunuz\n- Çalışma tarihleri\n\n(Örn: "ABC Teknoloji - CTO, 2025-Devam" veya "XYZ Yazılım - Kıdemli Yazılım Uzmanı, 2015-2016")',
    type: 'textarea',
    field: '_expInfo',
  },
  {
    id: 'exp_detail',
    section: 'experience',
    text: 'Bu işteki sorumluluklarınız, başarılarınız ve varsa yönettiğiniz ekip/bütçe bilgisini yazın.\n\n(Örn: "28 kişilik ekibi yönettim, maliyeti %70 düşürdüm, 300M TL bütçeyi yönettim")',
    type: 'textarea',
    field: '_expDetail',
  },
  {
    id: 'exp_more',
    section: 'experience',
    text: 'Başka iş deneyiminiz var mı?',
    type: 'choice',
    choices: [
      { label: 'Evet, başka deneyimim var', value: 'yes' },
      { label: 'Hayır, tüm deneyimlerimi ekledim', value: 'no' },
    ],
    field: '_expMore',
    loop: { onValue: 'yes', jumpTo: 'exp_info' },
  },

  // Eğitim
  {
    id: 'edu_info',
    section: 'education',
    text: 'Eğitim bilginizi yazın:\n\n- Okul adı ve bölüm\n- Eğitim düzeyi ve tarihler\n\n(Örn: "Ahmet Yesevi Üniversitesi - Bilgisayar Müh. Yüksek Lisans, 2010-2015")',
    type: 'textarea',
    field: '_eduInfo',
  },
  {
    id: 'edu_more',
    section: 'education',
    text: 'Başka eğitiminiz var mı?',
    type: 'choice',
    choices: [
      { label: 'Evet, başka eğitimim var', value: 'yes' },
      { label: 'Hayır, tamamlandı', value: 'no' },
    ],
    field: '_eduMore',
    loop: { onValue: 'yes', jumpTo: 'edu_info' },
  },

  // Beceriler
  {
    id: 'skills',
    section: 'skills',
    text: 'Teknik becerilerinizi ve kullandığınız teknoloji/araç/yazılımları yazın.\n\n(Virgülle ayırarak: C#, React, SAP, AutoCAD, Forklift vb.)',
    type: 'textarea',
    field: 'skills',
  },
  {
    id: 'certificates',
    section: 'skills',
    text: 'Mesleki sertifika, lisans veya belgeleriniz var mı?\n\n(Örn: AWS Certified, PMP, Ustalık Belgesi; yoksa "yok" yazabilirsiniz)',
    type: 'text',
    field: 'certificates',
  },
  {
    id: 'driverLicense',
    section: 'skills',
    text: 'Sürücü belgeniz var mı? Hangi sınıf? (Örn: B, C, E, Forklift; yoksa "yok")',
    type: 'text',
    field: 'driverLicense',
  },
  {
    id: 'english_level',
    section: 'skills',
    text: 'İngilizce seviyeniz nedir?',
    type: 'choice',
    choices: [
      { label: 'Hiç bilmiyorum', value: 'none' },
      { label: 'Temel (A1-A2)', value: 'basic' },
      { label: 'Orta (B1-B2)', value: 'intermediate' },
      { label: 'İleri (C1-C2)', value: 'advanced' },
      { label: 'Akıcı / Ana dil', value: 'fluent' },
    ],
    field: 'englishLevel',
  },
  {
    id: 'other_languages',
    section: 'skills',
    text: 'İngilizce dışında bildiğiniz diller ve seviyeleri? (yoksa "yok")\n\n(Örn: "Fransızca - Orta, Almanca - Temel")',
    type: 'text',
    field: 'otherLanguages',
  },

  // CV Tamamla
  {
    id: 'cv_name',
    section: 'cvFinish',
    text: 'CV\'nize bir isim verin.\n\n(Örn: "CTO CV", "Lojistik Uzmanı CV", "Genel CV")',
    type: 'text',
    field: 'cvName',
  },

  // Yurt Dışı Pivot
  {
    id: 'abroad_interest',
    section: 'abroad_pivot',
    text: 'CV\'niz hazır, yukarıdan kaydedebilirsiniz!\n\nYurt dışında (ABD veya Kanada) çalışmayı düşünüyor musunuz? Düşünüyorsanız birkaç soru daha sorup size özel bir kariyer profili hazırlayabilirim.',
    type: 'choice',
    choices: [
      { label: 'Evet, ilgileniyorum', value: 'yes' },
      { label: 'Şimdilik hayır', value: 'no' },
    ],
    field: 'abroadInterest',
  },

  // ══════════════════════════════════════════════
  // FAZ 2: YURT DIŞI MODÜLÜ
  // ══════════════════════════════════════════════

  {
    id: 'nationality',
    section: 'abroad_profile',
    text: 'Uyruğunuz / vatandaşlığınız?',
    type: 'text',
    field: 'nationality',
    condition: (a) => a.abroadInterest === 'yes',
  },
  {
    id: 'career_motivation',
    section: 'abroad_profile',
    text: 'Neden yurt dışında çalışmak istiyorsunuz? Sizi bu karara iten en önemli sebep nedir?',
    type: 'textarea',
    field: 'careerMotivation',
    condition: (a) => a.abroadInterest === 'yes',
  },
  {
    id: 'career_satisfaction',
    section: 'abroad_profile',
    text: 'Mevcut işinizde sizi en çok ne motive ediyor ve ne mutsuz ediyor?',
    type: 'textarea',
    field: 'careerSatisfaction',
    condition: (a) => a.abroadInterest === 'yes',
  },
  {
    id: 'work_environment',
    section: 'abroad_profile',
    text: 'Nasıl bir çalışma ortamı ve model tercih ediyorsunuz?',
    type: 'choice',
    choices: [
      { label: 'Tam ofis', value: 'office' },
      { label: 'Hibrit', value: 'hybrid' },
      { label: 'Uzaktan', value: 'remote' },
      { label: 'Saha / fabrika / restoran', value: 'field' },
      { label: 'Fark etmez', value: 'any' },
    ],
    field: 'workEnvironment',
    condition: (a) => a.abroadInterest === 'yes',
  },
  {
    id: 'target_country',
    section: 'abroad_target',
    text: 'Hangi ülkeyi hedefliyorsunuz?',
    type: 'choice',
    choices: [
      { label: 'ABD', value: 'usa' },
      { label: 'Kanada', value: 'canada' },
      { label: 'Her ikisi de olabilir', value: 'both' },
    ],
    field: 'targetCountry',
    condition: (a) => a.abroadInterest === 'yes',
  },
  {
    id: 'target_industry',
    section: 'abroad_target',
    text: 'Hangi sektör ve pozisyonu hedefliyorsunuz?\n\n(Örn: "Lojistik - İthalat Müşteri Temsilcisi" veya "Yazılım - Senior Developer")',
    type: 'textarea',
    field: 'targetIndustry',
    condition: (a) => a.abroadInterest === 'yes',
  },
  {
    id: 'target_state',
    section: 'abroad_target',
    text: 'Hedeflediğiniz bir eyalet veya şehir var mı?',
    type: 'text',
    field: 'targetState',
    condition: (a) => a.abroadInterest === 'yes',
  },
  {
    id: 'salary_expectation',
    section: 'abroad_target',
    text: 'Kabaca maaş beklentiniz nedir? (USD)\n\nVe olmazsa olmaz yan haklarınız? (Sağlık sigortası, izin vb.)',
    type: 'textarea',
    field: 'salaryExpectation',
    condition: (a) => a.abroadInterest === 'yes',
  },
  {
    id: 'relocation',
    section: 'abroad_target',
    text: 'Göç planınız nasıl?',
    type: 'choice',
    choices: [
      { label: 'Yalnız gideceğim', value: 'alone' },
      { label: 'Eşimle birlikte', value: 'spouse' },
      { label: 'Ailemle birlikte (eş + çocuklar)', value: 'family' },
    ],
    field: 'relocation',
    condition: (a) => a.abroadInterest === 'yes',
  },
  {
    id: 'visa_applied',
    section: 'abroad_visa',
    text: 'Daha önce ABD veya Kanada vizesine başvurdunuz mu?',
    type: 'choice',
    choices: [
      { label: 'Evet, onaylandı', value: 'approved' },
      { label: 'Evet, reddedildi', value: 'rejected' },
      { label: 'Hayır, hiç başvurmadım', value: 'never' },
    ],
    field: 'visaApplied',
    condition: (a) => a.abroadInterest === 'yes',
  },
  {
    id: 'visa_detail',
    section: 'abroad_visa',
    text: 'Vize detaylarını kısaca yazın. (Tür, tarih, geçerlilik veya ret gerekçesi)',
    type: 'textarea',
    field: 'visaDetail',
    condition: (a) => a.abroadInterest === 'yes' && a.visaApplied && a.visaApplied !== 'never',
  },
  {
    id: 'wait_tolerance',
    section: 'abroad_visa',
    text: 'Vize işlemleri 3-9 ay sürebilir. Bu bekleme süresini tolere edebilir misiniz?',
    type: 'choice',
    choices: [
      { label: 'Evet, hazırım', value: 'yes' },
      { label: 'Zor ama yapabilirim', value: 'maybe' },
      { label: 'Hayır, acil gitmem lazım', value: 'no' },
    ],
    field: 'waitTolerance',
    condition: (a) => a.abroadInterest === 'yes',
  },
  {
    id: 'financial_ready',
    section: 'abroad_visa',
    text: 'Taşınma ve ilk birkaç ay geçinme için finansal hazırlığınız var mı?',
    type: 'choice',
    choices: [
      { label: 'Evet, hazırım', value: 'yes' },
      { label: 'Kısmen', value: 'partial' },
      { label: 'Henüz değil', value: 'no' },
    ],
    field: 'financialReady',
    condition: (a) => a.abroadInterest === 'yes',
  },
  {
    id: 'unique_value',
    section: 'abroad_value',
    text: 'Sizi diğer adaylardan ayıran en güçlü yönünüz nedir? Neleri herkesten daha iyi yapıyorsunuz?',
    type: 'textarea',
    field: 'uniqueValue',
    condition: (a) => a.abroadInterest === 'yes',
  },
  {
    id: 'value_to_employer',
    section: 'abroad_value',
    text: 'Hedeflediğiniz şirkete ne gibi değer katabilirsiniz? Tecrübeleriniz onlara nasıl fayda sağlar?',
    type: 'textarea',
    field: 'valueToEmployer',
    condition: (a) => a.abroadInterest === 'yes',
  },
  {
    id: 'overseas_experience',
    section: 'abroad_adapt',
    text: 'Daha önce yurt dışında bulundunuz mu? Hangi ülkelerde, ne amaçla?',
    type: 'textarea',
    field: 'overseasExperience',
    condition: (a) => a.abroadInterest === 'yes',
  },
  {
    id: 'lower_position',
    section: 'abroad_adapt',
    text: 'İlk etapta mevcut seviyenizin altında bir pozisyonda başlamanız gerekebilir. Bunu kabul eder misiniz?',
    type: 'choice',
    choices: [
      { label: 'Evet, zaman içinde yükselmek isterim', value: 'accept' },
      { label: 'Zor ama denerim', value: 'try' },
      { label: 'Kendi seviyemden başlamalıyım', value: 'difficult' },
    ],
    field: 'lowerPosition',
    condition: (a) => a.abroadInterest === 'yes',
  },
  {
    id: 'contract_commitment',
    section: 'abroad_adapt',
    text: 'Sponsorluk karşılığında minimum 2 yıl çalışma taahhüdü verebilir misiniz?',
    type: 'choice',
    choices: [
      { label: 'Evet', value: 'yes' },
      { label: 'Görüşmek isterim', value: 'discuss' },
      { label: 'Hayır', value: 'no' },
    ],
    field: 'contractCommitment',
    condition: (a) => a.abroadInterest === 'yes',
  },
  {
    id: 'abroad_notes',
    section: 'abroad_finish',
    text: 'Eklemek istediğiniz başka bir bilgi var mı? (yoksa "yok" yazabilirsiniz)',
    type: 'textarea',
    field: 'abroadNotes',
    condition: (a) => a.abroadInterest === 'yes',
  },
];

// CV asistanı yalnızca CV sorularını sorar; yurt dışı akışı /panel/yurtdisi'nde.
// (Yurt dışı soruları ABROAD_QUESTIONS olarak ayrıca dışa aktarılıyor.)
export function buildFlow() {
  return QUESTIONS.filter((q) => !String(q.section || '').startsWith('abroad'));
}

export function getActiveQuestions(flow, answers) {
  return flow.filter(q => {
    if (!q.condition) return true;
    return q.condition(answers);
  });
}

export function getProgress(currentIndex, totalQuestions) {
  if (totalQuestions <= 0) return 0;
  return Math.round((currentIndex / totalQuestions) * 100);
}

export function getCurrentSection(questionId) {
  const q = QUESTIONS.find(qu => qu.id === questionId);
  if (!q) return null;
  return SECTIONS.find(s => s.id === q.section);
}

export function didSectionChange(prevQuestionId, currentQuestionId) {
  const prevSection = getCurrentSection(prevQuestionId);
  const currSection = getCurrentSection(currentQuestionId);
  if (!prevSection || !currSection) return false;
  return prevSection.id !== currSection.id;
}

export function isCvPhaseComplete(answers) {
  return !!answers.cvName;
}

export default QUESTIONS;

// Yurt dışı modülü soruları, CV asistanı dışında (/panel/yurtdisi) da kullanılır.
// Pivot sorusu ("yurt dışında çalışmayı düşünüyor musunuz?") hariç tutulur;
// o sayfada zaten niyeti belli olan aday var.
export const ABROAD_QUESTIONS = QUESTIONS.filter(
  (q) => q.section && q.section.startsWith('abroad_') && q.section !== 'abroad_pivot'
);

// Kaydedilen değeri (choice'larda value) ekranda gösterilecek etikete çevirir
export function abroadDisplayValue(question, value) {
  if (!question || value === null || value === undefined || value === '') return '';
  if (question.type === 'choice' && Array.isArray(question.choices)) {
    const match = question.choices.find((c) => c.value === value);
    return match ? match.label : String(value);
  }
  return String(value);
}

// ─────────────────────────────────────────────────────────────
// API'den gelen CV sorularını bu dosyadaki akış şekline çevirir.
// Böylece CvBuilderPage'in mevcut sohbet/döngü mantığı değişmeden çalışır.
//
// API alanları: { key, fieldKey, groupKey, section, title, placeholder,
//                 inputType, options, isRepeatable, isRequired, sortOrder }
// ─────────────────────────────────────────────────────────────

// Tekrarlanabilir grubun sonuna eklenen "başka var mı?" sorusu
function loopQuestion(groupKey, firstKey) {
  const labels = {
    experience: 'Başka iş deneyiminiz var mı?',
    education: 'Başka eğitiminiz var mı?',
  };
  return {
    id: `${groupKey}_more`,
    section: groupKey,
    text: labels[groupKey] || 'Bir tane daha eklemek ister misiniz?',
    type: 'choice',
    choices: [
      { label: 'Evet, ekleyeyim', value: 'yes' },
      { label: 'Hayır, devam', value: 'no' },
    ],
    field: `${groupKey}More`,
    loop: { onValue: 'yes', jumpTo: firstKey },
    generated: true,
  };
}

export function buildFlowFromApi(rawQuestions) {
  const list = (rawQuestions || [])
    .filter((q) => q && q.key)
    .slice()
    .sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0));

  const flow = [];
  let i = 0;

  while (i < list.length) {
    const raw = list[i];
    const repeatable = raw.isRepeatable === true;
    const groupKey = raw.groupKey || null;

    // Aynı tekrarlanabilir gruptaki ardışık sorular tek blok
    const block = [];
    while (
      i < list.length
      && list[i].isRepeatable === repeatable
      && (list[i].groupKey || null) === groupKey
    ) {
      block.push(list[i]);
      i += 1;
    }

    block.forEach((q) => {
      const inputType = String(q.inputType || 'text').toLowerCase();
      // options iki biçimde gelebiliyor: JSON dizi metni ("["Tam ofis","Hibrit"]")
      // ya da virgülle ayrılmış düz liste, bkz. services/api.js normalizeCvQuestion
      let options = [];
      if (q.options) {
        const text = String(q.options).trim();
        if (text.startsWith('[')) {
          try {
            const parsed = JSON.parse(text);
            if (Array.isArray(parsed)) options = parsed.map((o) => String(o));
          } catch {
            console.warn('[CV] options ayrıştırılamadı:', q.key, text);
          }
        } else {
          options = text.split(',').map((o) => o.trim()).filter(Boolean);
        }
      }

      flow.push({
        id: q.key,
        section: q.section || groupKey || 'general',
        text: q.title,
        placeholder: q.placeholder || '',
        type: inputType === 'select' ? 'choice'
          : inputType === 'textarea' ? 'textarea'
            : 'text',
        inputMode: inputType === 'email' ? 'email'
          : inputType === 'tel' ? 'tel'
            : inputType === 'month' ? 'month'
              : 'text',
        choices: options.map((o) => ({ label: o, value: o })),
        field: q.key,
        fieldKey: q.fieldKey || null,
        groupKey,
        required: q.isRequired === true,
      });
    });

    // Blok tekrarlanabiliyorsa döngü sorusu ekle
    if (repeatable && groupKey && block.length) {
      flow.push(loopQuestion(groupKey, block[0].key));
    }
  }

  // CV adı sorusu API'de yoksa sonuna ekle, kaydetmek için gerekli
  if (!flow.some((q) => /cvname|cv_name/i.test(q.fieldKey || q.id || ''))) {
    flow.push({
      id: 'cv_name',
      section: 'cvFinish',
      text: 'CV\'nize bir isim verin. (Örn: "Lojistik Uzmanı CV")',
      type: 'text',
      field: 'cvName',
      fieldKey: 'cv.name',
    });
  }

  return flow;
}

// API sorularının bölüm başlıkları, sohbette ayraç olarak gösterilir
export function sectionTitlesFromApi(rawQuestions) {
  const map = {};
  (rawQuestions || []).forEach((q) => {
    const id = q.section || q.groupKey;
    if (id && !map[id]) map[id] = q.section || id;
  });
  return map;
}
